import React, { useState } from "react";
import "./AdminRegisterForm1.css";

const AdminRegisterForm = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    role: "admin",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setMessage("");
    setError("");
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const res = await fetch(`${API_URL}/admin/adminregister`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(formData),
  //     });

  //     const data = await res.json();

  //     if (!res.ok) {
  //       setError(data.message || "Registration failed");
  //     } else {
  //       setMessage(data.message || "Admin registered successfully");
  //       setFormData({ username: "", email: "", password: "", role: "admin" });
  //     }
  //   } catch (err) {
  //     console.error("Registration error:", err);
  //     setError("Server error. Please try again later.");
  //   }
  // };
  const handleSubmit = async (e) => {
  e.preventDefault();

  setMessage("");
  setError("");

  try {
    const token = localStorage.getItem("token");

    if (!token) {
      setError("Please login first.");
      return;
    }

    const res = await fetch(`${API_URL}/admin/adminregister`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (!res.ok) {
      setError(data.message || "Registration failed");
      return;
    }

    setMessage(data.message || "Admin registered successfully");

    setFormData({
      username: "",
      email: "",
      password: "",
      role: "admin",
    });
  } catch (err) {
    console.error(err);
    setError("Server error. Please try again later.");
  }
};

  return (
    <div className="form-container">
      <h2 className="form-title">Register Admin</h2>

      {message && <p className="form-success">{message}</p>}
      {error && <p className="form-error">{error}</p>}

      <form onSubmit={handleSubmit} className="admin-form">
        <div className="form-group">
          <label>Username:</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label>Password:</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            minLength={9}
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label>Role:</label>
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            className="form-input"
          >
            <option value="admin">Admin</option>
            <option value="editor">Editor</option>
            <option value="viewer">Viewer</option>
          </select>
        </div>

        <button type="submit" className="form-button">
          Register
        </button>
      </form>
    </div>
  );
};

export default AdminRegisterForm;
